import { render, staticRenderFns } from "./EndOfRegistration.vue?vue&type=template&id=f58081d0&scoped=true"
import script from "./EndOfRegistration.vue?vue&type=script&lang=js"
export * from "./EndOfRegistration.vue?vue&type=script&lang=js"
import style0 from "./EndOfRegistration.vue?vue&type=style&index=0&id=f58081d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58081d0",
  null
  
)

export default component.exports